import api from '../../../../../api/api'
import url from '../../../../../api/env'
import Utils from '../../../../../utils/Utils'

const getCorrelativoIType = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api  
    .get(excludeChars ? `${url.stage.internalCorrelative}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.internalCorrelative}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const removeCorrelativoIType = async flagId =>
  api
    .remove(`${url.stage.internalCorrelative}/${flagId}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const editCorrelativoIType = async (flagId, data) =>
  api
    .put(`${url.stage.internalCorrelative}/${flagId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const newCorrelativoIType = async data =>
  api
    .post(url.stage.internalCorrelative, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  getCorrelativoIType,
  removeCorrelativoIType,
  editCorrelativoIType,
  newCorrelativoIType,
}
